import { C } from '../../data/tokens.js';

export function ClientEditModal({
  editingClient, setEditingClient, addClient, updateClient,
  setSelectedClient, attachClientTo, setAttachClientTo, attachReportToClient
}) {
  if (!editingClient) return null;

  return (
    <div role="dialog" aria-modal="true" aria-labelledby="modal-title" style={{ position: "absolute", inset: 0, background: "rgba(28,28,40,0.5)", backdropFilter: "blur(8px)", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
      onClick={() => setEditingClient(null)} onKeyDown={e => { if (e.key === "Escape") setEditingClient(null); }}>
      <div onClick={e => e.stopPropagation()} style={{ background: C.bg1, border: `1px solid ${C.border}`, borderRadius: 18, padding: "24px 22px", width: "100%", maxWidth: 340, boxShadow: "0 24px 64px rgba(0,0,0,0.6)" }}>
        <div id="modal-title" style={{ fontSize: 9, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: C.ghost, marginBottom: 6 }}>{editingClient.editing ? "Edit client" : "Add client"}</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 16 }}>
          <input type="text" placeholder="Client name" value={editingClient.name || ""}
            onChange={e => setEditingClient(p => ({ ...p, name: e.target.value }))}
            style={{ fontSize: 15, fontWeight: 600, background: C.bg2, border: `1px solid ${C.border}`, borderRadius: 10, padding: "10px 14px" }} />
          <input type="tel" placeholder="Phone number" value={editingClient.phone || ""}
            onChange={e => setEditingClient(p => ({ ...p, phone: e.target.value }))}
            style={{ fontSize: 14, fontFamily: "'IBM Plex Mono',monospace", background: C.bg2, border: `1px solid ${C.border}`, borderRadius: 10, padding: "10px 14px" }} />
          <input type="email" placeholder="Email" value={editingClient.email || ""}
            onChange={e => setEditingClient(p => ({ ...p, email: e.target.value }))}
            style={{ fontSize: 14, background: C.bg2, border: `1px solid ${C.border}`, borderRadius: 10, padding: "10px 14px" }} />
          <input type="text" placeholder="Address" value={editingClient.address || (editingClient.addresses?.[0] || "")}
            onChange={e => setEditingClient(p => ({ ...p, address: e.target.value }))}
            style={{ fontSize: 14, background: C.bg2, border: `1px solid ${C.border}`, borderRadius: 10, padding: "10px 14px" }} />
          <textarea placeholder="Notes (gate code, dog, payment terms…)" value={editingClient.notes || ""}
            onChange={e => setEditingClient(p => ({ ...p, notes: e.target.value }))}
            style={{ fontSize: 13, background: C.bg2, border: `1px solid ${C.border}`, borderRadius: 10, padding: "10px 14px", minHeight: 50 }} />
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => {
            if (editingClient.editing) {
              updateClient(editingClient.id, {
                name: editingClient.name, phone: editingClient.phone, email: editingClient.email,
                addresses: editingClient.address ? [editingClient.address] : (editingClient.addresses || []),
                notes: editingClient.notes,
              });
              setSelectedClient({ ...editingClient, addresses: editingClient.address ? [editingClient.address] : (editingClient.addresses || []) });
            } else {
              const newClient = addClient(editingClient);
              if (attachClientTo) {
                attachReportToClient(attachClientTo, newClient.id);
                setAttachClientTo(null);
              }
            }
            setEditingClient(null);
          }} style={{ flex: 1, padding: "14px 0", borderRadius: 12, background: C.gold, border: "none", color: C.bg0, fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>
            {editingClient.editing ? "Save" : "Add Client"}
          </button>
          <button onClick={() => { setEditingClient(null); setAttachClientTo(null); }}
            style={{ padding: "14px 16px", borderRadius: 12, background: "none", border: `1px solid ${C.border}`, color: C.muted, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans',sans-serif" }}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
